import { render } from "./StudentSkillsAssessment.vue?vue&type=template&id=0d3edf24"
import script from "./StudentSkillsAssessment.vue?vue&type=script&lang=js"
export * from "./StudentSkillsAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__